import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { resetPassword } from "../api.js";
import { withTranslation } from "react-i18next";

class PasswordReset extends Component {
	state = {
		password: "",
		errorMsg: ""
	}

	setNewPassword() {
		const { t } = this.props;
		const uname = localStorage.getItem("username");
		const c = localStorage.getItem("code");;

		resetPassword(uname, c, this.state.password, (r) => {
			if (r.status === 200) {
				this.setState({errorMsg: ""});
				window.location.replace("/login");
				return;
			}

			if (r.status >= 500) {
				this.setState({errorMsg: t("src_server_err")});
				return;
			}

			this.setState({errorMsg: t("pr_client_err")});
		});
	}

	render() {
		const { t } = this.props;

		return (
			<div>
				<div className="outer">
					<div className="middle">
						<div className="form-fields">
							<div className="logo">
								Lifecapsule
                <div className="signature">
									by{" "}
									<a href="https://leskor.com" alt="Ruslan Lesko">Ruslan Lesko</a>
								</div>
							</div>

							<div>
                <TextField
									label={t("new_password")}
									type="password"
                  margin="normal"
                  variant="outlined"
                  fullWidth={true}
                  onChange={(e) => this.setState({ password: e.target.value })}
                />
              </div>

							<div className="errorMsg">{this.state.errorMsg}</div>

							<div className="button">
								<Button
									variant="contained"
									color="primary"
									fullWidth={true}
									style={{ color: "white" }}
									onClick={() => this.setNewPassword()}
								>
									{t("set")}
								</Button>
							</div>

						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default withTranslation()(PasswordReset);